// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Optional)`
};

const de_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Optional)`
};

const es_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Opcional)`
};

const fr_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Optionnel)`
};

const fi_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Valinnainen)`
};

const hi_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(वैकल्पिक)`
};

const ja_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `（任意）`
};

const nl_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Optioneel)`
};

const pt_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Opcional)`
};

const ro_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Opțional)`
};

const th_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(ไม่บังคับ)`
};

const ur_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(اختیاری)`
};

const zh_hant1_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `（可選）`
};

const da_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Valgfrit)`
};

const it_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Opzionale)`
};

const vn_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Tùy chọn)`
};

const ko_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(선택사항)`
};

const tr_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(İsteğe bağlı)`
};

const lv_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Neobligāts)`
};

const ar_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(اختياري)`
};

const bs_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Opciono)`
};

const sl_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Neobvezno)`
};

const id_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Opsional)`
};

const sv_widget_login_optional = /** @type {(inputs: {}) => string} */ () => {
	return `(Valfritt)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_optional = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_optional(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_optional", locale)
	if (locale === "en") return en_widget_login_optional(inputs)
	if (locale === "de") return de_widget_login_optional(inputs)
	if (locale === "es") return es_widget_login_optional(inputs)
	if (locale === "fr") return fr_widget_login_optional(inputs)
	if (locale === "fi") return fi_widget_login_optional(inputs)
	if (locale === "hi") return hi_widget_login_optional(inputs)
	if (locale === "ja") return ja_widget_login_optional(inputs)
	if (locale === "nl") return nl_widget_login_optional(inputs)
	if (locale === "pt") return pt_widget_login_optional(inputs)
	if (locale === "ro") return ro_widget_login_optional(inputs)
	if (locale === "th") return th_widget_login_optional(inputs)
	if (locale === "ur") return ur_widget_login_optional(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_optional(inputs)
	if (locale === "da") return da_widget_login_optional(inputs)
	if (locale === "it") return it_widget_login_optional(inputs)
	if (locale === "vn") return vn_widget_login_optional(inputs)
	if (locale === "ko") return ko_widget_login_optional(inputs)
	if (locale === "tr") return tr_widget_login_optional(inputs)
	if (locale === "lv") return lv_widget_login_optional(inputs)
	if (locale === "ar") return ar_widget_login_optional(inputs)
	if (locale === "bs") return bs_widget_login_optional(inputs)
	if (locale === "sl") return sl_widget_login_optional(inputs)
	if (locale === "id") return id_widget_login_optional(inputs)
	if (locale === "sv") return sv_widget_login_optional(inputs)
	return "widget_login_optional"
};